import React, { useEffect } from 'react';
import { Modal } from '@mui/material';
import { isConsentReady } from 'app/components/onboardingFlows/flow.helpers';
import OnboardingFlowCard from 'app/components/onboardingFlows/OnboardingFlowCard';
import getFlows from 'app/components/onboardingFlows/OnboardingFlowManager';
const OnboardingFlow = _ref => {
  let {
    isAuthenticated
  } = _ref;
  const consentCompleted = isConsentReady();
  const [open, setOpen] = React.useState(false);
  const unViewedFlows = getFlows(isAuthenticated);
  useEffect(() => {
    if (consentCompleted) {
      setOpen(true);
    }
  }, [consentCompleted]);
  if (!unViewedFlows.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const handleClose = () => {
    setOpen(false);
    unViewedFlows.map(flow => flow.handleOnClose());
  };
  return /*#__PURE__*/React.createElement(Modal, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    open: open,
    onClose: handleClose,
    "aria-labelledby": "modal-modal-title",
    "aria-describedby": "modal-modal-description",
    "data-sentry-element": "Modal",
    "data-sentry-component": "OnboardingFlow",
    "data-sentry-source-file": "OnboardingFlow.tsx"
  }, /*#__PURE__*/React.createElement(OnboardingFlowCard, {
    flows: unViewedFlows,
    handleClose: handleClose,
    "data-sentry-element": "OnboardingFlowCard",
    "data-sentry-source-file": "OnboardingFlow.tsx"
  }));
};
export default OnboardingFlow;